import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

interface ISuccessScreenProps {
  onGoToLogin: () => void;
}

export const SuccessScreen = ({ onGoToLogin }: ISuccessScreenProps) => {
  return (
    <div className='w-full text-center py-8'>
      <div className='mb-6'>
        <span className='inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-4'>
          <CheckCircleOutlined className='text-5xl text-green-600' />
        </span>
      </div>

      <h3 className='text-2xl font-semibold mb-3 text-gray-800'>Đặt lại mật khẩu thành công!</h3>

      <p className='text-gray-600 mb-8'>
        Mật khẩu của bạn đã được thay đổi thành công.
        <br />
        Vui lòng đăng nhập bằng mật khẩu mới.
      </p>

      <Button type='primary' size='large' onClick={onGoToLogin} className='bg-[#1677ff] px-12'>
        Đăng nhập
      </Button>
    </div>
  );
};
